import { render } from "./training-card.vue?vue&type=template&id=13f802da&scoped=true&ts=true"
import script from "./training-card.vue?vue&type=script&lang=ts"
export * from "./training-card.vue?vue&type=script&lang=ts"

import "./training-card.vue?vue&type=style&index=0&id=13f802da&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13f802da"]])

export default __exports__